export var nrHeaderDataMapper = function (data) {
    var result = {};
    result = {
        grossRevenue: data.grossRevenue,
        sbPassOut: data.sbPassout,
        reversal: data.reversal,
        financeCost: data.financeCost,
        netRevenue: data.netRevenue,
        forQuarter: data.forQuarter,
        growthDegrowth: data.growthDegrowth ? data.growthDegrowth.toFixed(2) : 0,
        netRevenueL: data.netRevenueL,
        netRevenueLL: data.netRevenueLL,
        yearName: data.yearName,
    };
    return result;
};
